// Layout principale dell'applicazione: Sidebar + TopBar + Outlet
import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { cn } from '../../lib/utils'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'
import { MobileBottomNav } from './MobileBottomNav'
import { NotificationsPanel } from '../shared/NotificationsPanel'
import { GlobalSearch } from '../shared/GlobalSearch'
import { useOffline } from '../../hooks/useOffline'
import { useRealtime } from '../../hooks/useRealtime'

export function AppLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const [searchOpen, setSearchOpen] = useState(false)
  const [notificationsOpen, setNotificationsOpen] = useState(false)
  const { isOffline, wasOffline } = useOffline()

  // Inizializza connessione WebSocket
  useRealtime()

  return (
    <div className="min-h-screen bg-[var(--fc-background)]">
      {/* Sidebar desktop */}
      <div className="hidden md:block">
        <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />
      </div>

      {/* TopBar */}
      <TopBar
        sidebarCollapsed={sidebarCollapsed}
        onOpenSearch={() => setSearchOpen(true)}
        onOpenNotifications={() => setNotificationsOpen(true)}
      />

      {/* Contenuto principale */}
      <main
        className={cn(
          'pt-16 pb-20 md:pb-0 transition-[margin-left] duration-200',
          'md:ml-60',
          sidebarCollapsed && 'md:ml-16'
        )}
        id="main-content"
        tabIndex={-1}
      >
        {/* Banner offline */}
        {isOffline && (
          <div className="sticky top-16 z-20 flex items-center justify-center gap-2 bg-[var(--fc-warning)] px-4 py-2 text-sm font-medium text-white">
            <span className="h-2 w-2 rounded-full bg-white animate-pulse" aria-hidden="true" />
            Sei offline. Alcune funzionalità potrebbero non essere disponibili.
          </div>
        )}
        {wasOffline && !isOffline && (
          <div className="sticky top-16 z-20 flex items-center justify-center gap-2 bg-[var(--fc-success)] px-4 py-2 text-sm font-medium text-white animate-fc-fade-in">
            Connessione ripristinata
          </div>
        )}

        <div className="p-4 md:p-6">
          <Outlet />
        </div>
      </main>

      {/* Bottom nav mobile */}
      <MobileBottomNav />

      {/* Pannello notifiche */}
      <NotificationsPanel
        open={notificationsOpen}
        onClose={() => setNotificationsOpen(false)}
      />

      {/* Ricerca globale */}
      <GlobalSearch open={searchOpen} onClose={() => setSearchOpen(false)} />
    </div>
  )
}
